import yup, {
  stringRequired,
  stringRequiredIfFieldHasXValue,
  number,
} from "common/libs/yup";

export const listingGroupSectionReview = yup.object({
  status: number.min(1, "required"),
  reasons: yup.mixed().when("status", {
    is: value => value === 2,
    then: () => yup.array().of(yup.object({
      reason: stringRequired,
      description: stringRequiredIfFieldHasXValue("reason", ["incorrectInfo"]),
    }))
  })
})
